import $ from "jquery";

import {WEBGL} from 'three/examples/jsm/WebGL.js';
import * as THREE from "three";
import {threeGenerateScene} from "JQueryScripts/threejs/three-generate-scene";

const clock = new THREE.Clock();
const clearColor = new THREE.Color('#000');

let renderer;
let sceneInfoArray = [];
let delta;

export const Three = () => {
    const container = $('.three');

    if (container.length === 0) {
        return;
    }

    if (WEBGL.isWebGLAvailable()) {
        const canvas = $('#three-player-canvas');

        renderer = new THREE.WebGLRenderer({canvas: canvas[0], alpha: true, antialias: true});
        renderer.setPixelRatio(window.devicePixelRatio);
        renderer.shadowMap.enabled = true;

        container.each(async function() {
            if ($(this).children().length) {
                return;
            }

            const sceneInfo = await threeGenerateScene($(this));

            sceneInfoArray.push(sceneInfo);
        });

        render();


    } else {
        const warning = WEBGL.getWebGLErrorMessage();
        document.getElementById('container').appendChild(warning);
    }
};

const renderSceneInfo = (sceneInfo) => {
    const {scene, camera, sceneContainer, mixer, controls} = sceneInfo;
    const {left, right, top, bottom, width, height} = sceneContainer[0].getBoundingClientRect();

    const isOffscreen =
        bottom < 0 ||
        top > renderer.domElement.clientHeight ||
        right < 0 ||
        left > renderer.domElement.clientWidth;

    if (isOffscreen) {
        return;
    }

    camera.aspect = width / height;
    camera.updateProjectionMatrix();

    const positiveYUpBottom = renderer.domElement.clientHeight - bottom;
    renderer.setScissor(left, positiveYUpBottom, width, height);
    renderer.setViewport(left, positiveYUpBottom, width, height);

    if (mixer) {
        mixer.update(delta);
    }

    controls.update();

    renderer.render(scene, camera);
};

const resizeRendererToDisplaySize = (renderer) => {
    const canvas = renderer.domElement;
    const width = canvas.clientWidth;
    const height = canvas.clientHeight;
    const needResize = canvas.width !== width || canvas.height !== height;
    if (needResize) {
        renderer.setSize(width, height, false);
    }
    return needResize;
}

const render = () => {
    resizeRendererToDisplaySize(renderer);

    renderer.setScissorTest(false);
    renderer.setClearColor(clearColor, 0);
    renderer.clear(true, true);
    renderer.setScissorTest(true);

    requestAnimationFrame(render);

    delta = clock.getDelta();

    sceneInfoArray.forEach(renderSceneInfo);
}
